import { SliderButton } from "@typeform/embed-react";
import React from "react";
import { BsBugFill } from "react-icons/bs";

const ReportBtn = () => {
  return (
    <SliderButton id="ouLziHJy" style={{ fontSize: 20 }} className="my-button">
      <p className="btn-pink gap-x-2"> <BsBugFill />  Report Bug</p>
    </SliderButton>
  );
};

export default ReportBtn;